import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HanbaisakiKbn = props => {
  return <Dropdown.Static kubunKey='hanbaisaki_kbn' {...props} />
}
